import "@formatjs/intl-pluralrules/locale-data/en";
import "@formatjs/intl-pluralrules/locale-data/it";
import "@formatjs/intl-pluralrules/locale-data/nl";
import "@formatjs/intl-pluralrules/polyfill.js";
import "@formatjs/intl-relativetimeformat/locale-data/en";
import "@formatjs/intl-relativetimeformat/locale-data/it";
import "@formatjs/intl-relativetimeformat/locale-data/nl";
import "@formatjs/intl-relativetimeformat/polyfill.js";
import { useQuery } from "@apollo/client";
import {
  applyNomenclatureToMessages,
  isLocationNomenclature,
} from "@shared/constants/nomenclature";
import React from "react";
import { IntlProvider } from "react-intl";

import { CURRENT_USER_QUERY } from "~/api";
import languages from "~/lang";
import locationOverrides from "~/lang/locationOverrides";
import { useLanguageStore } from "~/stores/languageStore";

const LanguageProvider = ({ children }) => {
  const { lang } = useLanguageStore();
  // `cache-only` so the public routes (login, shared quote/invoice pages) never
  // fire an unauthenticated request; the app's own `currentUser` query fills
  // the cache and this watcher re-renders with it.
  const { data } = useQuery(CURRENT_USER_QUERY, { fetchPolicy: "cache-only" });

  const locationNomenclature = isLocationNomenclature(
    data?.currentUser?.oem?.installedProducts,
  );

  const messages = React.useMemo(() => {
    const catalogue = languages[lang.locale];
    if (!locationNomenclature) return catalogue;
    return applyNomenclatureToMessages(
      catalogue,
      locationOverrides[lang.locale],
    );
  }, [lang.locale, locationNomenclature]);

  return (
    <IntlProvider
      locale={lang.locale}
      defaultLocale={lang.locale}
      messages={messages}
    >
      {children}
    </IntlProvider>
  );
};

export default LanguageProvider;
